import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ClientFormCreate  from '../ClientFormCreate';
import api3003 from '../../services/api3003';

const Title = styled.h1`
  font-size: 28px;
  margin: ${({$filtrar}) => ( $filtrar ? "5px" : "20px")};
  padding:0;
  font-family: 'Arial', sans-serif;
  color: #333;
  text-align: center;
  transition: margin 0.2s ease;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const UserTableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    overflow-x: hidden;
  }
`;

const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: 768px) {
    display: none; /* Esconde a tabela original em telas pequenas */
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const TableHead = styled.thead`
  background-color: #151e3d;
  color: white;
  text-align: left;
`;

const TableHeadCell = styled.th`
  padding: 10px;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #d3d3d3;
  opacity: ${(props) => (props.isInactive ? 0.5 : 1)};
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const Button = styled.button`
  margin: 2px;
  padding: ${({$smal}) => ($smal ? "3px 6px" : "6px 12px")};
  font-size: ${({$smal}) => ($smal ? "11px" : "14px")};
  cursor: pointer;
  border: 1px solid #007bff;
  border-radius: 6px;
  color: #007bff;
  background-color: transparent;
  white-space: nowrap;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    transform: scale(0.98);
    background-color: #0056b3;
  }
`;


const EditButton = styled(Button)`
  color: #007bff;
  border-color: #007bff;

  &:hover {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
  }

  &:active {
    background-color: #0056b3;
    border-color: #0056b3;
  }
`;
/*
const InactivateButton = styled(Button)`
  color: red;
  border-color: red;

  &:hover {
    background-color: red;
    color: white;
    border-color: red;
  }

  &:active {
    background-color: darkred;
    border-color: darkred;
  }
`;

const ActivateButton = styled(Button)`
  color: green;
  border-color: green;

  &:hover {
    background-color: green;
    color: white;
    border-color: green;
  }

  &:active {
    background-color: darkgreen;
    border-color: darkgreen;
  }
`;*/

const CreateButton = styled(Button)`
  color: #007bff;
  border-color: #007bff;

  &:hover {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
  }

  &:active {
    background-color: #0056b3;
    border-color: #0056b3;
  }
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

// Estilo para tabelas responsivas em telas pequenas (div de cartão)
const CardWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block; /* Exibe as linhas de dados como "cartões" em telas pequenas */
    margin-top: 20px;
  }
`;

const UserCard = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const UserCardItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  & > span {
    font-weight: bold;
    color: #333;
  }
`;

const UserCardValue = styled.div`
  background-color: #e9ecef;
  padding: 5px 10px;
  border-radius: 4px;
  color: #495057;
  font-size: 14px;
`;

const FiltrosWrapper = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 5px;
  wrap: no-wrap

  transition: 
    max-height 0.35s ease,
    opacity 0.3s ease,
    transform 0.3s ease;
`;

const FilterInput = styled.input`
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.8rem;
`;

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
`;



const UserList = () => {
  const [clients, setClients] = useState([]);
  const [error, setError] = useState(null);
  const [editingClient, setEditingClient] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createButtonClicked, setCreateButtonClicked] = useState(false);

  const [filtrar, setFiltrar] = useState(false);

  const [filtroNomeInput, setFiltroNomeInput] = useState('');
  const [filtroDocumentoInput, setFiltroDocumentoInput] = useState('');

  const [filtroNomeAplicado, setFiltroNomeAplicado] = useState('');
  const [filtroDocumentoAplicado, setFiltroDocumentoAplicado] = useState('');

  const fetchClients = () => {
    const token = localStorage.getItem('token');

    api3003.get('/api/clients', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        setClients(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          setError('Acesso proibido: Token inválido ou expirado.');
        } else {
          setError(`Erro: ${error.response?.statusText || error.message}`);
        }
        console.error('Erro ao buscar clientes:', error);
      });
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleCreateButtonClick = () => {
    setCreateButtonClicked(true);
    setShowCreateModal(true);
  };

  const listaFiltrada = clients.filter((client) => {

    const nomeMatch = filtroNomeAplicado
      ? client.nome?.toLowerCase().includes(filtroNomeAplicado.toLowerCase())
      : true;

    const documentoMatch = filtroDocumentoAplicado
      ? (
          client.cpf?.toLowerCase().includes(filtroDocumentoAplicado.toLowerCase()) ||
          client.cnpj?.toLowerCase().includes(filtroDocumentoAplicado.toLowerCase())
        )
      : true;

    return nomeMatch && documentoMatch;
  });

  const formatCpfCnpj = (value) => {
    if (!value) return '';

    const numbers = value.replace(/\D/g, '');

    if (numbers.length === 11) {
      return numbers.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );
    }

    if (numbers.length === 14) {
      return numbers.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    }

    return numbers;
  };

  return (
    <div>
      <Title $filtrar={filtrar}>Clientes</Title>

      <CenteredContainer>
      <CreateButton
        onClick={handleCreateButtonClick}
        className={createButtonClicked ? 'clicked' : ''}
        >
        Cadastrar Cliente
      </CreateButton>

        <Button onClick={() => setFiltrar(!filtrar)}>
          Filtros {filtrar ? "▼" : "▲"}
        </Button>
      </CenteredContainer>

      {filtrar && (
        <FiltrosWrapper>

          <FilterInput
            placeholder="Razão Social / Nome"
            value={filtroNomeInput}
            onChange={(e) => setFiltroNomeInput(e.target.value)}
          />

          <FilterInput
            placeholder="CPF ou CNPJ"
            value={filtroDocumentoInput}
            onChange={(e) => setFiltroDocumentoInput(e.target.value)}
          />

          <Button onClick={() => {
            setFiltroNomeAplicado(filtroNomeInput);
            setFiltroDocumentoAplicado(filtroDocumentoInput);
          }}>
            Aplicar
          </Button>

          <Button onClick={() => {
            setFiltroNomeInput('');
            setFiltroDocumentoInput('');
            setFiltroNomeAplicado('');
            setFiltroDocumentoAplicado('');
          }}>
            Limpar
          </Button>

        </FiltrosWrapper>
      )}
      

      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

      <UserTableWrapper>
        <UserTable>
          <TableHead>
            <tr>
              <TableHeadCell>Razão Social / Nome</TableHeadCell>
              <TableHeadCell>CPF / CNPJ</TableHeadCell>
              <TableHeadCell>Email</TableHeadCell>
              <TableHeadCell>Telefone</TableHeadCell>
              <TableHeadCell></TableHeadCell>
            </tr>
          </TableHead>
          <tbody>
            {listaFiltrada.map((client) => (
              <TableRow key={client.id}>
                <TableCell>{client.nome}</TableCell>
                <TableCell>{formatCpfCnpj(client.cpf || client.cnpj)}</TableCell>
                <TableCell>{client.email}</TableCell>
                <TableCell>{client.telefone}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <EditButton onClick={() => setEditingClient(client)}>Editar</EditButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </UserTable>
      </UserTableWrapper>
      
      <CardWrapper>
        {clients.map((client) => (
          <UserCard key={client.id}>
            <UserCardItem>
              <span>ID:</span> <UserCardValue>{client.id}</UserCardValue>
            </UserCardItem>
            <UserCardItem>
              <span>Razão Social:</span> <UserCardValue>{client.nome}</UserCardValue>
            </UserCardItem>
            <UserCardItem>
              <span>CPF/CNPJ:</span> 
              <UserCardValue>{formatCpfCnpj(client.cpf || client.cnpj)}</UserCardValue>
            </UserCardItem>
            <UserCardItem>
              <span>Email:</span> <UserCardValue>{client.email}</UserCardValue>
            </UserCardItem>
            <UserCardItem>
              <span>Telefone:</span> <UserCardValue>{client.telefone}</UserCardValue>
            </UserCardItem>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <EditButton onClick={() => setEditingClient(client)}>Editar</EditButton>
            </div>
          </UserCard>
        ))}
      </CardWrapper>

      {/* Modais */}
      {editingClient && (
        <ModalOverlay>
        <ClientFormCreate onClose={() => setEditingClient(false)} onCreated={fetchClients} client={editingClient} />
      </ModalOverlay>
      )}

      {showCreateModal && (
        <ModalOverlay>
          <ClientFormCreate onClose={() => setShowCreateModal(false)} onCreated={fetchClients} />
        </ModalOverlay>
      )}
    </div>
  );
};

export default UserList;
